import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { useAppRoutes } from '@root/features/routing'
import { CommentIcon, InfoMessage } from '@root/shared/ui-kit'

export const CommentsHistoryEmpty = () => {
  const { t } = useTranslation()
  const { navigateToRoot } = useAppRoutes()

  const handleExploreTokens = () => navigateToRoot()

  return (
    <Root>
      <InfoMessage
        withBackground
        intent="empty"
        variant="bold"
        icon={<CommentIcon />}
        title={t('comment.history.empty-title')}
        description={t('comment.history.empty-description')}
        retryText={t('common.explore-tokens')}
        onRetry={handleExploreTokens}
      />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
`
